import cn from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { DropdownMenu, PLACEMENT, TRIGGER } from '../../core/dropdown-menu/DropdownMenu';
import style from '../../theme/theme-switcher/style';
import { SUPPORTED_LANGUAGES, useLocalizationContext } from '../LocalizationProvider';
import { Translate } from '../Translate';

const Styled = styled.div`
  ${style}
`;

export const LocaleSwitcher = ({ className, persist = true }) => {
  const { userLocale, setUserLocale } = useLocalizationContext();

  const handleChange = React.useCallback(
    value => {
      setUserLocale(value, persist);
    },
    [persist, setUserLocale]
  );

  return (
    <Styled className={cn('locale-switcher', className)}>
      <DropdownMenu
        trigger={[TRIGGER.CLICK]}
        placement={PLACEMENT.TOP_LEFT}
        menuItems={SUPPORTED_LANGUAGES.map(language => ({ id: language.id, stringId: `languages.${language.id}` }))}
        onClick={handleChange}
        activeId={userLocale}
      >
        <div className="dropdown-content">
          <div className="icon">
            <i className="fa-solid fa-globe" />
          </div>
          <div className="label">
            <Translate stringId={`languages.${userLocale}`} data-testid="locale-switcher" />
          </div>
        </div>
      </DropdownMenu>
    </Styled>
  );
};
